module.exports = __webpack_public_path__ + "static/media/cross.30f5b69c.svg";